import { init as initLocales, setLocale } from '@ihme/common/locale';

import en from './en';

export const init = () => {
    initLocales({ en });
    setLocale('en');
};
